import { useEffect, useState } from "react";
import { SelectComponents } from "~/components/ui";
import { cn } from "~/lib/utils.ts";

import { ErrorProps, FormError } from ".";
import { SearchableDropdown } from "../ui/special-dropdown/searchable-select";

interface Option {
  label: string;
  value: string;
}
type Props = {
  autoFocus?: boolean;
  label: string;
  required?: boolean;
  readOnly?: boolean;
  errors?: ErrorProps;
  options: Option[];
  defaultValue?: Option;
  placeholder?: string;
  components?: Partial<SelectComponents>;
  searchPlaceholder?: string;
  onChange: (option: Option) => void;
  prefix?: React.ReactNode;
  value: Option;
};

export default function FormSearchableSelectInput({
  label,
  required,
  errors,
  options,
  defaultValue,
  onChange,
  placeholder,
  searchPlaceholder,
  prefix,
  value: propValue,
  readOnly,
}: Props) {
  const [value, setValue] = useState<Option | undefined>(
    defaultValue || propValue,
  );

  useEffect(() => setValue(propValue), [propValue]);

  return (
    <div>
      <label className="space-y-1">
        <div
          className={cn("font-Medium text-sm", {
            "text-danger-500": errors?.error,
          })}
        >
          {label} {required && <span className="text-danger-400">*</span>}
        </div>
        <SearchableDropdown
          onChange={(option) => {
            onChange(option);
            setValue(option);
          }}
          readOnly={readOnly}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          options={options}
          searchPlaceholder={searchPlaceholder}
          className={cn("border-neutral-300 text-sm hover:ring-0", {
            "border-danger-500": errors && errors.error,
          })}
          prefix={prefix}
        />
        <FormError error={errors?.error} message={errors?.message} />
      </label>
    </div>
  );
}
